import { z } from "zod";

import { LoginOption, SKUPageContentTheme, SKUPageType } from "@/data/types";

export const skuFormSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, "Name is required")
    .max(75, "Name must be less than 75 characters"),
  image_url: z.union([z.url(), z.literal("")]).optional(),
  animation_url: z.union([z.url(), z.literal("")]).optional(),
  description: z.string().optional(),
  header_logo_url: z.union([z.url(), z.literal("")]).optional(),
  builder_io_url: z.string().optional(),
  builder_io_api_key: z.string().optional(),
  login_options: z.array(z.enum(LoginOption)),
  redirect_url: z.union([z.url(), z.literal("")]).optional(),
  sku_code: z
    .union([
      z
        .string()
        .regex(
          /^[A-Z0-9]+$/i,
          "Only letters and numbers allowed in SKU codes.",
        ),
      z.literal(""),
    ])
    .optional(),
  upc: z
    .string()
    .optional()
    .refine((val) => {
      if (!val) return true;
      const digits = val.replace(/\D/g, "");
      return digits.length === 12;
    }),

  notes: z.string().optional(),
  analytics_url: z.union([z.url(), z.literal("")]).optional(),
  nft_chain_id: z.number().optional(),
  // @todo: separate static system values from user input forms
  nft_token_id: z.number().optional(),
  total_tags_count: z.number().optional(),
  page_type: z.union([
    z.literal(SKUPageType.LEGITIMATE),
    z.literal(SKUPageType.REDIRECT),
    z.literal(SKUPageType.BUILDER_IO),
  ]),
  theme: z.union([
    z.literal(SKUPageContentTheme.DARK),
    z.literal(SKUPageContentTheme.LIGHT),
    z.literal(SKUPageContentTheme.SYSTEM),
  ]),
  display_serial_number: z.boolean().default(true),
});

export type SKUFormValues = z.infer<typeof skuFormSchema>;
